import { render, staticRenderFns } from "./reg_detail.vue?vue&type=template&id=6cbd6f01"
import script from "./reg_detail.vue?vue&type=script&lang=js"
export * from "./reg_detail.vue?vue&type=script&lang=js"
import style0 from "./reg_detail.vue?vue&type=style&index=0&id=6cbd6f01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports